var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShikshaModel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 351.001,
    height: 350.965,
    viewBox: "0 0 351.001 350.965",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#ff4b10;}.a,.b,.c{fill-rule:evenodd;}.b{fill:#08bc14;}.c{fill:#0164ae;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-785 -1017)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M527.14,78.115C601.527-26.04,752.989-19.875,820.229,86.35l-6.71,26.228-25.009-6.4C734.793,20.663,616.648,20.1,557.333,98.549l-3.05-24.7-27.143,4.27Z",
    transform: "translate(288.365 1013.752)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M2947.534,1777.49c51.824,117.029-30.54,244.29-156.2,248.135l-19.166-19.12,18.237-18.272c100.945-2.743,161.532-104.172,124.175-195.145l22.819,9.942Z",
    transform: "translate(-1827.273 -658.233)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M157.3,1748.058C29.963,1735.178-39.864,1600.63,18.978,1489.534l26.1-7.194,6.853,24.89C4.359,1596.306,62.516,1699.147,160.056,1711.7l-19.932,14.909Z",
    transform: "translate(787.147 -380.094)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShikshaModel);
export default __webpack_public_path__ + "static/media/shiksha-model.39d42930f4403cb9acd92a2093333940.svg";
export { ForwardRef as ReactComponent };